import useScopedDashboardAccess from "@/auth/hooks/useScopedDashboardAccess";

type UseHidePostActionsOptions = {
  allowEsgWrite?: boolean;
};

export const useHidePostActions = (
  ownerCarrierId?: number | null,
  options?: UseHidePostActionsOptions,
) => {
  const { canEditEsgScope, isReadOnlyScope } =
    useScopedDashboardAccess(ownerCarrierId);

  if (options?.allowEsgWrite && canEditEsgScope) {
    return false;
  }

  return isReadOnlyScope;
};

export default useHidePostActions;
